import isNil from 'lodash/isNil';
import wrappedAxios from './wrappedAxios';

export const fetchSplitTreatments = async ({ id, splits, attributes }) => {
  const userId = isNil(id) ? 'unknown' : id;
  const response = await wrappedAxios({
    url: `/hotels/split/treatments`,
    method: 'get',
    params: {
      id: userId,
      splits: splits.join(','),
      attributes: JSON.stringify(attributes || {}),
    },
  });

  return response.data;
};

export const trackSplitEvent = async ({ id, event, value, properties }) => {
  const userId = isNil(id) ? 'unknown' : id;
  const response = await wrappedAxios({
    url: `/hotels/split/events`,
    method: 'post',
    data: {
      id: userId,
      event,
      value,
      properties,
    },
  });

  return response.data;
};
